// extracted by mini-css-extract-plugin
module.exports = {"center":"pre-loading-modal_center__1j4dV"};